import { render, staticRenderFns } from "./OrderAction.vue?vue&type=template&id=fe43fca0&scoped=true"
import script from "./OrderAction.vue?vue&type=script&lang=js"
export * from "./OrderAction.vue?vue&type=script&lang=js"
import style0 from "./OrderAction.vue?vue&type=style&index=0&id=fe43fca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe43fca0",
  null
  
)

export default component.exports